import { Dialog } from "primereact/dialog";
import { useState, useCallback } from "react";
import { createPortal } from "react-dom";

export function useConfirmModal() {
  const [state, setState] = useState({
    isOpen: false,
    title: "",
    message: "",
  });

  const [resolver, setResolver] = useState<null | ((v: boolean) => void)>(null);

  const confirm = useCallback((message: string, title = "Onay") => {
    setState({ isOpen: true, title, message });

    return new Promise<boolean>((resolve) => {
      // resolver fonksiyonunu saklıyoruz
      setResolver(() => resolve);
    });
  }, []);

  const handleConfirm = () => {
    setState((prev) => ({ ...prev, isOpen: false }));
    resolver?.(true);
  };

  const handleCancel = () => {
    setState((prev) => ({ ...prev, isOpen: false }));
    resolver?.(false);
  };

  const modal = state.isOpen
    ? createPortal(
        <Dialog
          visible={state.isOpen}
          onHide={handleCancel}
          header={state.title}  
          style={{ width: "400px", zIndex: 9999 }}
          maskStyle={{ zIndex: 9999 }}
          maximizable
          resizable={false}
        >
          <p className="mb-4">{state.message}</p>

          <div className="flex justify-end gap-2 mt-4">
            <button
                      className="btn-cancel"
              onClick={handleCancel}
            >
              İptal
            </button>

            <button
              className="px-4 py-2 btn btn-danger"
              onClick={handleConfirm}
            >
              Onayla
            </button>
          </div>
        </Dialog>,
        document.body
      )
    : null;

  return { confirm, modal };
}
